export default "__VITE_ASSET__EjP7CCkr__"